<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import ChatRoomItemTypeGuard from "../Models/Typeguards/ChatRoomItem";
import type { AllowedChatRoomItemType } from "@/Modules/Chat/Models/Domain/Chat";

import { parseText, TEXT_PART_TYPE } from "@/Modules/Chat/Components/utils/TextMessagesParsers";
import { isObject } from "@/Utils/Objects";
import { isString } from "@/Utils/String";

export interface EventTextProps {
  event: AllowedChatRoomItemType;
}

const props = defineProps<EventTextProps>();
const { t } = useI18n();

const parts = computed(() => {
  if (isObject(props.event) && isString(props.event.text)) {
    return parseText(props.event.text);
  }
  return [];
});
</script>

<template>
  <span v-if="parts.length">
    <template v-for="(part, index) in parts" :key="index">
      <template v-if="part.type === TEXT_PART_TYPE.TEXT">
        {{ part.value }}
      </template>

      <a
        v-else-if="part.type === TEXT_PART_TYPE.URL"
        :href="part.value.startsWith('http') ? part.value : `https://${part.value}`"
        target="_blank"
      >
        {{ part.value }}
      </a>

      <a v-else-if="part.type === TEXT_PART_TYPE.EMAIL" :href="`mailto:${part.value}`">
        {{ part.value }}
      </a>
    </template>
  </span>

  <span v-else-if="ChatRoomItemTypeGuard.isCustom(event) && event.i18nKey">
    {{ t(event.i18nKey, event.params ? event.params : {}) }}
  </span>

  <span v-else />
</template>
